// import React, { useEffect, useState } from "react";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import PrimaryButton from "../buttons/PrimaryButton";
// import { parseISO, format } from "date-fns";
// import axios from "axios";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import Modal from "../modal/Modal";
// import Pagination from "../pagination/Pagination";
// import Cookies from "js-cookie";
// import confirmIcon from "../../assets/img/iconamoon--shield-yes-fill.svg";

// const AdminSectorsTable = ({
//   pending,
//   searchQuery,
//   startDate,
//   endDate,
//   refreshTrigger,
// }) => {
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const baseUrl = process.env.REACT_APP_BASE_URL;
//   const [loadingState, setLoadingState] = useState({ id: null, action: null });
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
//   const [userToDelete, setUserToDelete] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [error, setError] = useState("");
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [confirmLoading, setConfirmLoading] = useState(false);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [multipleDeleteLoading, setMultipleDeleteLoading] = useState(false);
//   const [multipleActionLoading, setMultipleActionLoading] = useState(false);
//   const [showActionSuccess, setShowActionSuccess] = useState(false);
//   const [showActionConfirm, setShowActionConfirm] = useState(false);
//   const [actionUser, setActionUser] = useState(null);
//   const [actionType, setActionType] = useState(null);
//   const [isMultipleDelete, setIsMultipleDelete] = useState(false);
//   const [isMultipleAction, setIsMultipleAction] = useState(false);
//   const [showReactivateConfirm, setShowReactivateConfirm] = useState(false);
//   const [userToReactivate, setUserToReactivate] = useState(null);

//   // Re-assign role states
//   const [showReassignModal, setShowReassignModal] = useState(false);
//   const [userToReassign, setUserToReassign] = useState(null);
//   const [newRole, setNewRole] = useState("");
//   const [newName, setNewName] = useState("");
//   const [newEmail, setNewEmail] = useState("");
//   const [reassignLoading, setReassignLoading] = useState(false);
//   const [reassignError, setReassignError] = useState("");
//   const [showReassignSuccess, setShowReassignSuccess] = useState(false);

//   // Location states for scanner assistant
//   const [provinces, setProvinces] = useState([]);
//   const [districts, setDistricts] = useState([]);
//   const [sectors, setSectors] = useState([]);
//   const [sites, setSites] = useState([]);
//   const [selectedProvince, setSelectedProvince] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedSector, setSelectedSector] = useState("");
//   const [locationError, setLocationError] = useState("");

//   const entriesPerPage = 10;

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentEntries = filteredUsers.slice(
//     indexOfFirstEntry,
//     indexOfLastEntry
//   );
//   const totalPages = Math.ceil(filteredUsers.length / entriesPerPage);

//   const formatDate = (dateString) => {
//     const parsedDate = parseISO(dateString);
//     return format(parsedDate, "dd MMM yyyy");
//   };

//   const formatStatus = (status) => {
//     if (!status) return "";
//     return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
//   };

//   const actionDisabled = (status) => {
//     return status === "APPROVED" || status === "REJECTED";
//   };

//   const deleteDisabled = (status) => {
//     return status === "Not Active";
//   };

//   const handleSelectAll = (e) => {
//     const isChecked = e.target.checked;
//     setIsAllSelected(isChecked);

//     if (isChecked) {
//       setSelectedUsers(
//         currentEntries
//           .filter(
//             (user) =>
//               !actionDisabled(user.status) && !deleteDisabled(user.status)
//           )
//           .map((user) => user.uuid || user.id)
//       );
//     } else {
//       setSelectedUsers([]);
//     }
//   };

//   const handleSelectUser = (e, userId) => {
//     const isChecked = e.target.checked;

//     setSelectedUsers((prev) => {
//       if (isChecked) {
//         return [...prev, userId];
//       } else {
//         const newSelected = prev.filter((id) => id !== userId);
//         setIsAllSelected(
//           newSelected.length ===
//             currentEntries.filter(
//               (user) =>
//                 !actionDisabled(user.status) && !deleteDisabled(user.status)
//             ).length
//         );
//         return newSelected;
//       }
//     });
//   };

//   useEffect(() => {
//     setSelectedUsers([]);
//     setIsAllSelected(false);
//   }, [filteredUsers]);

//   useEffect(() => {
//     const getUsers = async () => {
//       try {
//         const token = Cookies.get("token");
//         const endpoint = pending
//           ? `${baseUrl}/api/users/requests`
//           : `${baseUrl}/api/users`;
//         const res = await axios.get(endpoint, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const sortedUsers = [...res.data].sort((a, b) => {
//           if (a.status === "Not Active" && b.status !== "Not Active") return 1;
//           if (a.status !== "Not Active" && b.status === "Not Active") return -1;

//           return new Date(b.createdAt) - new Date(a.createdAt);
//         });
//         setUsers(sortedUsers);
//         setFilteredUsers(sortedUsers);
//       } catch (error) {
//         console.error(error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     getUsers();
//   }, [baseUrl, pending, refreshTrigger]);

//   useEffect(() => {
//     const handleFilters = async () => {
//       setSearchLoading(true);
//       await new Promise((resolve) => setTimeout(resolve, 1000));
//       let filtered = [...users];

//       if (searchQuery?.trim()) {
//         const searchLower = searchQuery?.toLowerCase();
//         filtered = filtered.filter((user) => {
//           const nameMatch =
//             user.name?.toLowerCase().includes(searchLower) || false;
//           const emailMatch =
//             user.email?.toLowerCase().includes(searchLower) || false;
//           const roleMatch =
//             user.role?.toLowerCase().includes(searchLower) || false;
//           return nameMatch || emailMatch || roleMatch;
//         });
//       }

//       if (startDate && endDate) {
//         const start = new Date(startDate);
//         start.setHours(0, 0, 0, 0);

//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);

//         filtered = filtered.filter((user) => {
//           const createdDate = new Date(user.createdAt);
//           return createdDate >= start && createdDate <= end;
//         });
//       }

//       filtered.sort((a, b) => {
//         if (a.status === "Not Active" && b.status !== "Not Active") return 1;
//         if (a.status !== "Not Active" && b.status === "Not Active") return -1;
//         return new Date(b.createdAt) - new Date(a.createdAt);
//       });

//       setFilteredUsers(filtered);
//       setSearchLoading(false);
//     };

//     handleFilters();
//   }, [searchQuery, users, startDate, endDate]);

//   const handleDeleteClick = (user) => {
//     setUserToDelete(user);
//     setShowDeleteConfirm(true);
//   };

//   const handleConfirmDelete = async () => {
//     setLoadingState({ id: userToDelete.uuid, action: "DELETE" });
//     setConfirmLoading(true);
//     try {
//       const token = Cookies.get("token");
//       const res = await axios.delete(
//         `${baseUrl}/api/users/${userToDelete.uuid}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       if (res.status === 200) {
//         setUsers((prevUsers) =>
//           prevUsers.map((user) =>
//             user.uuid === userToDelete.uuid
//               ? { ...user, status: "Not Active", deletedAt: new Date() }
//               : user
//           )
//         );
//         setFilteredUsers((prevUsers) =>
//           prevUsers.map((user) =>
//             user.uuid === userToDelete.uuid
//               ? { ...user, status: "Not Active", deletedAt: new Date() }
//               : user
//           )
//         );
//         setIsMultipleDelete(false);
//         setShowDeleteSuccess(true);
//       }
//     } catch (error) {
//       if (error.response) {
//         if (error.response.status === 400) {
//           setError("Error: User does not exist.");
//         } else {
//           console.error("Error deleting user:", error);
//           setError("Error deleting user. Please try again.");
//         }
//       }
//     } finally {
//       setLoadingState({ id: null, action: null });
//       setUserToDelete(null);
//       setConfirmLoading(false);
//       setShowDeleteConfirm(false);
//     }
//   };

//   const getStatusClass = (status) => {
//     const statusMap = {
//       APPROVED: "status-approved",
//       REJECTED: "status-declined",
//       PENDING: "status-pending",
//       Active: "status-active",
//       Inactive: "status-inactive",
//       "Not Active": "status-inactive",
//     };
//     return `status ${statusMap[status]}`;
//   };

//   const formatRole = (role) => {
//     const roleMap = {
//       SUPER_ADMIN: "Super Admin",
//       CLIENT: "Client",
//       SCANNER_OPERATOR: "Scanner Operator",
//       DATA_ENTRY_CLERK: "Data Entry Clerk",
//       PROJECT_COORDINATOR: "Project Coordinator",
//       SCANNER_ASSISTANT: "Scanner Assistant",
//       SUPERVISOR: "Supervisor",
//     };
//     return roleMap[role] || role;
//   };

//   const updateUserStatus = async (id, status) => {
//     setLoadingState({ id, action: status });
//     setShowActionConfirm(false);
//     try {
//       const token = Cookies.get("token");
//       const res = await axios.put(
//         `${baseUrl}/api/users/requests/${id}`,
//         { status },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (res.status === 200) {
//         setUsers((prevUsers) =>
//           prevUsers.map((user) => (user.id === id ? { ...user, status } : user))
//         );
//         setFilteredUsers((prevUsers) =>
//           prevUsers.map((user) => (user.id === id ? { ...user, status } : user))
//         );
//         setIsMultipleAction(false);
//         setShowActionSuccess(true);
//       }
//     } catch (error) {
//       setError("Error updating status");
//     } finally {
//       setLoadingState({ id: null, action: null });
//       setActionUser(null);
//     }
//   };

//   const handleMultipleDelete = async () => {
//     if (selectedUsers.length === 0) return;

//     setMultipleDeleteLoading(true);
//     setShowDeleteConfirm(false);

//     try {
//       const token = Cookies.get("token");
//       const res = await axios.delete(`${baseUrl}/api/users/multiple/delete`, {
//         headers: { Authorization: `Bearer ${token}` },
//         data: { uuids: selectedUsers },
//       });

//       if (res.status === 200) {
//         const updatedUsers = users.map((user) =>
//           selectedUsers.includes(user.uuid)
//             ? { ...user, status: "Not Active", deletedAt: new Date() }
//             : user
//         );
//         setUsers(updatedUsers);
//         setFilteredUsers(updatedUsers);
//         setSelectedUsers([]);
//         setIsAllSelected(false);
//         setIsMultipleDelete(true);
//         setShowDeleteSuccess(true);
//       }
//     } catch (error) {
//       setError("Error deleting multiple users");
//     } finally {
//       setMultipleDeleteLoading(false);
//     }
//   };

//   const handleMultipleAction = async (status) => {
//     if (selectedUsers.length === 0) return;

//     setMultipleActionLoading(true);
//     setShowActionConfirm(false);

//     try {
//       const token = Cookies.get("token");
//       const res = await axios.put(
//         `${baseUrl}/api/users/multiple/requests`,
//         { ids: selectedUsers, status },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (res.status === 200) {
//         setUsers((prevUsers) =>
//           prevUsers.map((user) =>
//             selectedUsers.includes(user.id) ? { ...user, status } : user
//           )
//         );
//         setFilteredUsers((prevUsers) =>
//           prevUsers.map((user) =>
//             selectedUsers.includes(user.id) ? { ...user, status } : user
//           )
//         );

//         setSelectedUsers([]);
//         setIsAllSelected(false);
//         setShowActionSuccess(true);
//         setIsMultipleAction(true);
//       }
//     } catch (error) {
//       setError("Error updating multiple users");
//     } finally {
//       setMultipleActionLoading(false);
//     }
//   };

//   // handle multiple delete click with multiple users
//   const handleMultipleDeleteClick = () => {
//     if (selectedUsers.length > 0) {
//       setShowDeleteConfirm(true);
//     }
//   };

//   const handleActionClick = (user, status) => {
//     setActionUser(user);
//     setActionType(status);
//     setShowActionConfirm(true);
//   };

//   const handleMultipleApproveClick = () => {
//     if (selectedUsers.length > 0) {
//       setActionType("APPROVED");
//       setShowActionConfirm(true);
//     }
//   };

//   const handleMultipleRejectClick = () => {
//     if (selectedUsers.length > 0) {
//       setActionType("REJECTED");
//       setShowActionConfirm(true);
//     }
//   };

//   const handleCloseActionConfirm = () => {
//     setShowActionConfirm(false);
//     setActionUser(null);
//     setActionType(null);
//   };

//   const handleCloseActionSuccess = () => {
//     setShowActionSuccess(false);
//     setActionType(null);
//     setIsMultipleAction(false);
//   };

//   const handleCloseReactivateConfirm = () => {
//     setShowReactivateConfirm(false);
//     setUserToReactivate(null);
//   };

//   const handleCloseModal = () => {
//     setShowDeleteConfirm(false);
//   };

//   const handleCloseDeleteSuccess = () => {
//     setShowDeleteSuccess(false);
//     setIsMultipleDelete(false);
//   };

//   useEffect(() => {
//     let timer;
//     if (showDeleteSuccess) {
//       timer = setTimeout(() => {
//         handleCloseDeleteSuccess();
//       }, 3000);
//     }

//     return () => {
//       if (timer) {
//         clearTimeout(timer);
//       }
//     };
//   }, [showDeleteSuccess]);

//   useEffect(() => {
//     let timer;
//     if (showActionSuccess) {
//       timer = setTimeout(() => {
//         handleCloseActionSuccess();
//       }, 3000);
//     }
//     return () => {
//       if (timer) clearTimeout(timer);
//     };
//   }, [showActionSuccess]);

//   const handleReactivateUser = async (user) => {
//     setUserToReactivate(user);
//     setShowReactivateConfirm(true);
//   };

//   const handleConfirmReactivate = async () => {
//     setLoadingState({ id: userToReactivate.uuid, action: "REACTIVATE" });
//     setError("");
//     try {
//       const token = Cookies.get("token");
//       const res = await axios.put(
//         `${baseUrl}/api/users/${userToReactivate.uuid}/reactivate`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       if (res.status === 200) {
//         setUsers((prevUsers) =>
//           prevUsers.map((u) =>
//             u.uuid === userToReactivate.uuid
//               ? { ...u, status: "Active", deletedAt: null }
//               : u
//           )
//         );
//         setFilteredUsers((prevUsers) =>
//           prevUsers.map((u) =>
//             u.uuid === userToReactivate.uuid
//               ? { ...u, status: "Active", deletedAt: null }
//               : u
//           )
//         );
//         setShowReactivateConfirm(false);
//         setUserToReactivate(null);
//       }
//     } catch (error) {
//       setError("Error reactivating user");
//     } finally {
//       setLoadingState({ id: null, action: null });
//     }
//   };

//   // Re-assign role functions
//   const handleReassignRole = (user) => {
//     setUserToReassign(user);
//     setNewRole(user.role);
//     setNewName(user.name);
//     setNewEmail(user.email);
//     setSelectedProvince("");
//     setSelectedDistrict("");
//     setSelectedSector("");
//     setReassignError("");
//     setLocationError("");
//     setShowReassignModal(true);
//   };

//   const handleCloseReassignModal = () => {
//     setShowReassignModal(false);
//     setUserToReassign(null);
//     setNewRole("");
//     setSelectedProvince("");
//     setSelectedDistrict("");
//     setSelectedSector("");
//     setReassignError("");
//     setLocationError("");
//   };

//   const handleCloseReassignSuccess = () => {
//     setShowReassignSuccess(false);
//   };

//   // Fetch location data when role changes to SCANNER_ASSISTANT
//   useEffect(() => {
//     if (showReassignModal && newRole === "SCANNER_ASSISTANT") {
//       const fetchSites = async () => {
//         try {
//           const token = Cookies.get("token");
//           const response = await axios.get(`${baseUrl}/api/sites`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           const sitesData = response.data;
//           setSites(sitesData);

//           const uniqueProvinces = [
//             ...new Set(sitesData.map((site) => site.province)),
//           ].sort();
//           const uniqueDistricts = [
//             ...new Set(sitesData.map((site) => site.district)),
//           ].sort();
//           const uniqueSectors = [
//             ...new Set(
//               sitesData
//                 .map((site) => site.sector)
//                 .filter((sector) => sector !== null)
//             ),
//           ].sort();

//           setProvinces(uniqueProvinces);
//           setDistricts(uniqueDistricts);
//           setSectors(uniqueSectors);
//         } catch (error) {
//           setReassignError("Failed to load location data");
//         }
//       };

//       fetchSites();
//     } else {
//       setProvinces([]);
//       setDistricts([]);
//       setSectors([]);
//       setSites([]);
//       setSelectedProvince("");
//       setSelectedDistrict("");
//       setSelectedSector("");
//       setLocationError("");
//     }
//   }, [showReassignModal, newRole, baseUrl]);

//   const handleRoleChange = (e) => {
//     setNewRole(e.target.value);
//     setSelectedProvince("");
//     setSelectedDistrict("");
//     setSelectedSector("");
//     setLocationError("");
//   };

//   const handleProvinceChange = (e) => {
//     setSelectedProvince(e.target.value);
//     setSelectedDistrict("");
//     setSelectedSector("");
//   };

//   const handleDistrictChange = (e) => {
//     setSelectedDistrict(e.target.value);
//     setSelectedSector("");
//   };

//   const handleSectorChange = (e) => {
//     setSelectedSector(e.target.value);
//   };

//   const validateReassignForm = () => {
//     if (!newRole) {
//       setReassignError("Please select a role");
//       return false;
//     }

//     if (
//       newRole === "SCANNER_ASSISTANT" &&
//       (!selectedProvince || !selectedDistrict)
//     ) {
//       setLocationError(
//         "Province and district are required for Scanner Assistant"
//       );
//       return false;
//     }

//     return true;
//   };

//   const handleSubmitReassign = async (e) => {
//     e.preventDefault();

//     if (!validateReassignForm()) {
//       return;
//     }

//     setReassignLoading(true);
//     setReassignError("");
//     setLocationError("");

//     try {
//       const token = Cookies.get("token");
//       const requestData = {
//         ...(newName.trim() && { name: newName }),
//         ...(newEmail.trim() && { email: newEmail }),
//         role: newRole,
//         ...(newRole === "SCANNER_ASSISTANT" && {
//           province: selectedProvince,
//           district: selectedDistrict,
//           ...(selectedSector && { sector: selectedSector }),
//         }),
//       };

//       const res = await axios.put(
//         `${baseUrl}/api/users/${userToReassign.uuid}/update-role`,
//         requestData,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (res.status === 200) {
//         // Update the user in the local state
//         setUsers((prevUsers) =>
//           prevUsers.map((user) =>
//             user.uuid === userToReassign.uuid
//               ? {
//                   ...user,
//                   role: newRole,
//                   ...(newName.trim() && { name: newName }),
//                   ...(newEmail.trim() && { email: newEmail }),
//                 }
//               : user
//           )
//         );
//         setFilteredUsers((prevUsers) =>
//           prevUsers.map((user) =>
//             user.uuid === userToReassign.uuid
//               ? {
//                   ...user,
//                   role: newRole,
//                   ...(newName.trim() && { name: newName }),
//                   ...(newEmail.trim() && { email: newEmail }),
//                 }
//               : user
//           )
//         );

//         setShowReassignModal(false);
//         setShowReassignSuccess(true);
//       }
//     } catch (error) {
//       if (error.response) {
//         if (error.response.status === 409) {
//           setReassignError(
//             "A scanner assistant is already assigned to this site."
//           );
//         } else if (error.response.status === 400) {
//           setReassignError(error.response.data.error || "Invalid input");
//         } else if (error.response.status === 404) {
//           setReassignError("Site not found");
//         } else {
//           setReassignError(
//             error.response.data.error || "Error updating user role"
//           );
//         }
//       } else {
//         setReassignError("Server is not responding. Please try again later");
//       }
//     } finally {
//       setReassignLoading(false);
//     }
//   };

//   // Auto-close success modal
//   useEffect(() => {
//     let timer;
//     if (showReassignSuccess) {
//       timer = setTimeout(() => {
//         handleCloseReassignSuccess();
//       }, 3000);
//     }
//     return () => {
//       if (timer) clearTimeout(timer);
//     };
//   }, [showReassignSuccess]);

//   return (
//     <>
//       {selectedUsers.length > 0 && !pending && (
//         <div
//           className="table-controls"
//           style={{ marginBottom: "20px", marginRight: "20px" }}
//         >
//           <PrimaryButton
//             text={
//               multipleDeleteLoading ? (
//                 <AiOutlineLoading3Quarters className="loader" />
//               ) : (
//                 `Delete ${selectedUsers.length} User${
//                   selectedUsers.length > 1 ? "s" : ""
//                 }`
//               )
//             }
//             icon="mingcute:delete-fill"
//             onClick={handleMultipleDeleteClick}
//             disabled={multipleDeleteLoading}
//             style={{ backgroundColor: "#E2000033", color: "#E20000" }}
//           />
//         </div>
//       )}

//       {selectedUsers.length > 0 && pending && (
//         <div
//           className="table-controls"
//           style={{ marginBottom: "20px", marginRight: "20px" }}
//         >
//           <PrimaryButton
//             text={
//               multipleActionLoading && actionType === "APPROVED" ? (
//                 <AiOutlineLoading3Quarters className="loader" />
//               ) : (
//                 `Approve ${selectedUsers.length} User${
//                   selectedUsers.length > 1 ? "s" : ""
//                 }`
//               )
//             }
//             icon="dashicons:yes"
//             onClick={handleMultipleApproveClick}
//             disabled={multipleActionLoading}
//             style={{ backgroundColor: "#078ECE", color: "#FFFFFF" }}
//           />
//           <PrimaryButton
//             text={
//               multipleActionLoading && actionType === "REJECTED" ? (
//                 <AiOutlineLoading3Quarters className="loader" />
//               ) : (
//                 `Reject ${selectedUsers.length} User${
//                   selectedUsers.length > 1 ? "s" : ""
//                 }`
//               )
//             }
//             icon="dashicons:no"
//             onClick={handleMultipleRejectClick}
//             disabled={multipleActionLoading}
//             style={{
//               backgroundColor: "#E2000033",
//               color: "#E20000",
//               marginLeft: "20px",
//               marginTop: "10px",
//             }}
//           />
//         </div>
//       )}
//       <table className="admin">
//         <thead>
//           <tr>
//             <th>
//               <input
//                 type="checkbox"
//                 id="selectAll"
//                 checked={isAllSelected}
//                 onChange={handleSelectAll}
//               />
//             </th>
//             <th>Name</th>
//             <th>Email ID</th>
//             <th>Role</th>
//             <th>Status</th>
//             <th>Date</th>
//             <th style={{ textAlign: "center" }}>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {loading || searchLoading ? (
//             Array.from({ length: 5 }).map((_, index) => (
//               <tr key={index}>
//                 <td>
//                   <Skeleton width={20} height={20} />
//                 </td>
//                 <td>
//                   <Skeleton width={100} />
//                 </td>
//                 <td>
//                   <Skeleton width={150} />
//                 </td>
//                 <td>
//                   <Skeleton width={100} />
//                 </td>
//                 <td>
//                   <Skeleton width={80} />
//                 </td>
//                 <td>
//                   <Skeleton width={100} />
//                 </td>
//                 {pending && (
//                   <td>
//                     <Skeleton width={100} />
//                   </td>
//                 )}
//               </tr>
//             ))
//           ) : filteredUsers.length === 0 ? (
//             <tr style={{ boxShadow: "none" }}>
//               <td colSpan="7" style={{ textAlign: "center", color: "#9B9B9B" }}>
//                 No users found
//               </td>
//             </tr>
//           ) : (
//             currentEntries.map((user, index) => (
//               <tr key={index + 1}>
//                 <td>
//                   <input
//                     type="checkbox"
//                     checked={selectedUsers.includes(user.uuid || user.id)}
//                     onChange={(e) => handleSelectUser(e, user.uuid || user.id)}
//                     disabled={
//                       actionDisabled(user.status) || deleteDisabled(user.status)
//                     }
//                   />
//                 </td>
//                 <td>{user.name}</td>
//                 <td>{user.email}</td>
//                 <td>{formatRole(user.role)}</td>
//                 <td>
//                   <span className={getStatusClass(user.status)}>
//                     {formatStatus(user.status)}
//                   </span>
//                 </td>
//                 <td>{formatDate(user.createdAt)}</td>
//                 {!pending && (
//                   <td
//                     className="delete"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "10px",
//                     }}
//                   >
//                     {user.status === "Not Active" ? (
//                       <PrimaryButton
//                         text={
//                           loadingState.id === user.uuid &&
//                           loadingState.action === "REACTIVATE" ? (
//                             <AiOutlineLoading3Quarters className="loader" />
//                           ) : (
//                             "Reactivate"
//                           )
//                         }
//                         icon="material-symbols:restart-alt"
//                         onClick={() => handleReactivateUser(user)}
//                         disabled={
//                           loadingState.id === user.uuid &&
//                           loadingState.action === "REACTIVATE"
//                         }
//                         style={{
//                           backgroundColor:
//                             loadingState.id === user.uuid &&
//                             loadingState.action === "REACTIVATE"
//                               ? "#cccccc"
//                               : "#E6F4EA",
//                           color:
//                             loadingState.id === user.uuid &&
//                             loadingState.action === "REACTIVATE"
//                               ? "#666666"
//                               : "#007011",
//                           minWidth: 110,
//                           cursor:
//                             loadingState.id === user.uuid &&
//                             loadingState.action === "REACTIVATE"
//                               ? "not-allowed"
//                               : "pointer",
//                         }}
//                       />
//                     ) : (
//                       <>
//                         <a
//                           onClick={() => handleReassignRole(user)}
//                           style={{ backgroundColor: "#4E7FFF33" }}
//                         >
//                           <Icon
//                             icon="mdi:book-edit"
//                             width="20"
//                             height="20"
//                             color="#4E7FFF"
//                           />
//                         </a>
//                         <a
//                           onClick={() => handleDeleteClick(user)}
//                           aria-label="Delete"
//                           className={`${
//                             loadingState.id === user.uuid ||
//                             deleteDisabled(user.status)
//                               ? "btn-disabled"
//                               : ""
//                           }`}
//                           disabled={
//                             loadingState.id === user.uuid ||
//                             deleteDisabled(user.status)
//                           }
//                         >
//                           <Icon
//                             icon="mingcute:delete-fill"
//                             width="20"
//                             height="20"
//                             color="#E20000"
//                           />
//                         </a>
//                       </>
//                     )}
//                   </td>
//                 )}
//                 {pending && (
//                   <td>
//                     <div className="action-buttons">
//                       <PrimaryButton
//                         text={
//                           loadingState.id === user.id &&
//                           loadingState.action === "APPROVED" ? (
//                             <AiOutlineLoading3Quarters className="loader" />
//                           ) : (
//                             "Approve"
//                           )
//                         }
//                         icon="dashicons:yes"
//                         className={`${
//                           loadingState.id === user.id &&
//                           loadingState.action === "APPROVED"
//                             ? "btn-disabled"
//                             : ""
//                         } ${actionDisabled(user.status) ? "btn-disabled" : ""}`}
//                         disabled={
//                           loadingState.id === user.id ||
//                           actionDisabled(user.status)
//                         }
//                         onClick={() => handleActionClick(user, "APPROVED")}
//                       />
//                       <PrimaryButton
//                         text={
//                           loadingState.id === user.id &&
//                           loadingState.action === "REJECTED" ? (
//                             <AiOutlineLoading3Quarters className="loader" />
//                           ) : (
//                             "Decline"
//                           )
//                         }
//                         className={`${
//                           loadingState.id === user.id &&
//                           loadingState.action === "REJECTED"
//                             ? "btn-disabled"
//                             : ""
//                         } ${actionDisabled(user.status) ? "btn-disabled" : ""}`}
//                         disabled={
//                           loadingState.id === user.id ||
//                           actionDisabled(user.status)
//                         }
//                         onClick={() => handleActionClick(user, "REJECTED")}
//                       />
//                     </div>
//                   </td>
//                 )}
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//       {!loading && filteredUsers.length > 0 && (
//         <Pagination
//           currentPage={currentPage}
//           totalItems={filteredUsers.length}
//           entriesPerPage={entriesPerPage}
//           onPageChange={setCurrentPage}
//         />
//       )}

//       {showDeleteConfirm && (
//         <Modal
//           onClose={() => setShowDeleteConfirm(false)}
//           show={showDeleteConfirm}
//         >
//           <div className="content confirmation">
//             <h2>Confirm Delete</h2>
//             <div className="text">
//               {selectedUsers.length > 1 ? (
//                 <>
//                   Are you sure you want to delete the following{" "}
//                   {selectedUsers.length} users?
//                   <ul style={{ listStyleType: "none", padding: "10px 0" }}>
//                     {currentEntries
//                       .filter((user) =>
//                         selectedUsers.includes(user.uuid || user.id)
//                       )
//                       .map((user) => (
//                         <li key={user.uuid || user.id}>
//                           <strong>{user.name}</strong> ({user.email}) -{" "}
//                           {formatRole(user.role)}
//                         </li>
//                       ))}
//                   </ul>
//                 </>
//               ) : (
//                 <>
//                   Are you sure you want to delete the user: {userToDelete?.name}{" "}
//                   ({userToDelete?.email}) with the role{" "}
//                   <strong>{formatRole(userToDelete?.role)}</strong>?
//                 </>
//               )}
//             </div>
//             <div className="button-group">
//               <PrimaryButton
//                 text={
//                   confirmLoading || multipleDeleteLoading ? (
//                     <AiOutlineLoading3Quarters className="loader" />
//                   ) : (
//                     "Yes"
//                   )
//                 }
//                 onClick={
//                   selectedUsers.length > 1
//                     ? handleMultipleDelete
//                     : handleConfirmDelete
//                 }
//                 disabled={confirmLoading || multipleDeleteLoading}
//               />
//               <PrimaryButton
//                 text="No"
//                 onClick={handleCloseModal}
//                 disabled={confirmLoading || multipleDeleteLoading}
//               />
//             </div>
//           </div>
//         </Modal>
//       )}

//       {showActionConfirm && (
//         <Modal onClose={handleCloseActionConfirm} show={showActionConfirm}>
//           <div className="content confirmation">
//             <h2>
//               {actionType === "APPROVED"
//                 ? "Confirm Approval"
//                 : actionType === "REJECTED"
//                 ? "Confirm Rejection"
//                 : "Confirm Action"}
//             </h2>
//             <div className="text">
//               {selectedUsers.length > 1 ? (
//                 <>
//                   Are you sure you want to{" "}
//                   {actionType === "APPROVED" ? "approve" : "reject"} the
//                   following {selectedUsers.length} users?
//                   <ul style={{ listStyleType: "none", padding: "10px 0" }}>
//                     {currentEntries
//                       .filter((user) =>
//                         selectedUsers.includes(user.uuid || user.id)
//                       )
//                       .map((user) => (
//                         <li key={user.uuid || user.id}>
//                           <strong>{user.name}</strong> ({user.email}) -{" "}
//                           {formatRole(user.role)}
//                         </li>
//                       ))}
//                   </ul>
//                 </>
//               ) : actionUser ? (
//                 <>
//                   Are you sure you want to {actionType?.toLowerCase()} this
//                   user: <strong>{actionUser?.name}</strong> ({actionUser?.email}
//                   ) with the role {formatRole(actionUser?.role)}?
//                 </>
//               ) : (
//                 <p>Are you sure you want to delete this user?</p>
//               )}
//             </div>
//             <div className="button-group">
//               <PrimaryButton
//                 text={
//                   loadingState.id || multipleActionLoading ? (
//                     <AiOutlineLoading3Quarters className="loader" />
//                   ) : (
//                     "Yes"
//                   )
//                 }
//                 onClick={
//                   selectedUsers.length > 1
//                     ? () => handleMultipleAction(actionType)
//                     : () => updateUserStatus(actionUser.id, actionType)
//                 }
//                 disabled={loadingState.id || multipleActionLoading}
//               />
//               <PrimaryButton
//                 text="No"
//                 onClick={handleCloseActionConfirm}
//                 disabled={loadingState.id || multipleActionLoading}
//               />
//             </div>
//           </div>
//         </Modal>
//       )}

//       {showDeleteSuccess && (
//         <Modal onClose={handleCloseDeleteSuccess} show={showDeleteSuccess}>
//           <div className="content confirmation">
//             <div className="icon-container">
//               <img
//                 src={confirmIcon}
//                 alt="confirm"
//                 width="57"
//                 height="57"
//                 style={{ color: "#007011" }}
//               />
//             </div>
//             <div className="text">
//               {isMultipleDelete
//                 ? "Users have been successfully deleted!"
//                 : "User has been successfully deleted!"}
//             </div>
//           </div>
//         </Modal>
//       )}

//       {showActionSuccess && (
//         <Modal onClose={handleCloseActionSuccess} show={showActionSuccess}>
//           <div className="content confirmation">
//             <div className="icon-container">
//               <img
//                 src={confirmIcon}
//                 alt="confirm"
//                 width="57"
//                 height="57"
//                 style={{ color: "#007011" }}
//               />
//             </div>
//             <div className="text">
//               {isMultipleAction
//                 ? `Users have been successfully ${
//                     actionType === "APPROVED" ? "approved" : "declined"
//                   }!`
//                 : `User has been successfully ${
//                     actionType === "APPROVED" ? "approved" : "declined"
//                   }!`}
//             </div>
//           </div>
//         </Modal>
//       )}

//       {showReactivateConfirm && (
//         <Modal
//           onClose={handleCloseReactivateConfirm}
//           show={showReactivateConfirm}
//         >
//           <div className="content confirmation">
//             <h2>Confirm Reactivation</h2>
//             <div className="text">
//               Are you sure you want to reactivate the user:{" "}
//               {userToReactivate?.name}({userToReactivate?.email}) with the role{" "}
//               {formatRole(userToReactivate?.role)}?
//             </div>
//             <div className="button-group">
//               <PrimaryButton
//                 text={
//                   loadingState.id ? (
//                     <AiOutlineLoading3Quarters className="loader" />
//                   ) : (
//                     "Yes"
//                   )
//                 }
//                 onClick={handleConfirmReactivate}
//                 disabled={loadingState.id}
//               />
//               <PrimaryButton
//                 text="No"
//                 onClick={handleCloseReactivateConfirm}
//                 disabled={loadingState.id}
//               />
//             </div>
//           </div>
//         </Modal>
//       )}

//       {/* Re-assign Role Modal */}
//       {showReassignModal && (
//         <Modal show={showReassignModal} onClose={handleCloseReassignModal}>
//           <div className="title">UPDATE USER DETAILS</div>
//           <div className="content">
//             <div className="form-container">
//               <form onSubmit={handleSubmitReassign}>
//                 <div className="email-and-password">
//                   <div className="label">
//                     <div>Name</div>
//                     <input
//                       placeholder="User name"
//                       type="text"
//                       value={newName}
//                       onChange={(e) => setNewName(e.target.value)}
//                     />
//                   </div>

//                   <div className="label">
//                     <div>Email</div>
//                     <input
//                       placeholder="User email"
//                       type="text"
//                       value={newEmail}
//                       onChange={(e) => setNewEmail(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <div className="label">
//                   <div>Current Role</div>
//                   <input
//                     placeholder="Current role"
//                     type="text"
//                     value={formatRole(userToReassign?.role) || ""}
//                     disabled
//                   />
//                 </div>

//                 <div className="label">
//                   <div>New Role</div>
//                   <select value={newRole} onChange={handleRoleChange}>
//                     <option value="" disabled>
//                       Select New Role
//                     </option>
//                     <option value="SUPER_ADMIN">Admin</option>
//                     <option value="SCANNER_OPERATOR">Scanner Operator</option>
//                     <option value="CLIENT">Client</option>
//                     <option value="DATA_ENTRY_CLERK">Data Entry Clerk</option>
//                     <option value="PROJECT_COORDINATOR">
//                       Project Coordinator
//                     </option>
//                     <option value="SUPERVISOR">Supervisor</option>
//                     <option value="SCANNER_ASSISTANT">Scanner Assistant</option>
//                   </select>
//                 </div>

//                 {newRole === "SCANNER_ASSISTANT" && (
//                   <>
//                     <div className="label">
//                       <div>Province</div>
//                       <select
//                         name="province"
//                         value={selectedProvince}
//                         onChange={handleProvinceChange}
//                         required
//                       >
//                         <option value="" disabled>
//                           Select Province
//                         </option>
//                         {provinces.map((province) => (
//                           <option key={province} value={province}>
//                             {province}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="label">
//                       <div>District</div>
//                       <select
//                         name="district"
//                         value={selectedDistrict}
//                         onChange={handleDistrictChange}
//                         disabled={!selectedProvince}
//                         required
//                       >
//                         <option value="" disabled>
//                           Select District
//                         </option>
//                         {districts
//                           .filter((district) =>
//                             sites.some(
//                               (site) =>
//                                 site.province === selectedProvince &&
//                                 site.district === district
//                             )
//                           )
//                           .map((district) => (
//                             <option key={district} value={district}>
//                               {district}
//                             </option>
//                           ))}
//                       </select>
//                     </div>
//                     <div className="label">
//                       <div>Sector</div>
//                       <select
//                         name="sector"
//                         value={selectedSector}
//                         onChange={handleSectorChange}
//                         disabled={!selectedDistrict}
//                       >
//                         <option value="" disabled>
//                           Select Sector (Optional)
//                         </option>
//                         {sectors
//                           .filter((sector) =>
//                             sites.some(
//                               (site) =>
//                                 site.province === selectedProvince &&
//                                 site.district === selectedDistrict &&
//                                 site.sector === sector
//                             )
//                           )
//                           .map((sector) => (
//                             <option key={sector} value={sector}>
//                               {sector}
//                             </option>
//                           ))}
//                       </select>
//                     </div>
//                   </>
//                 )}
//               </form>
//               {reassignError && (
//                 <div className="error-message">{reassignError}</div>
//               )}
//               {locationError && (
//                 <div className="error-message">{locationError}</div>
//               )}
//             </div>
//             <div className="button-group">
//               <PrimaryButton
//                 text={
//                   reassignLoading ? (
//                     <AiOutlineLoading3Quarters className="loader" />
//                   ) : (
//                     "Update User"
//                   )
//                 }
//                 onClick={handleSubmitReassign}
//                 disabled={reassignLoading}
//               />
//               <PrimaryButton
//                 text="Cancel"
//                 onClick={handleCloseReassignModal}
//                 disabled={reassignLoading}
//               />
//             </div>
//           </div>
//         </Modal>
//       )}

//       {/* Re-assign Success Modal */}
//       {showReassignSuccess && (
//         <Modal onClose={handleCloseReassignSuccess} show={showReassignSuccess}>
//           <div className="content confirmation">
//             <div className="icon-container">
//               <img
//                 src={confirmIcon}
//                 alt="confirm"
//                 width="57"
//                 height="57"
//                 style={{ color: "#007011" }}
//               />
//             </div>
//             <div className="text">User role has been successfully updated!</div>
//           </div>
//         </Modal>
//       )}
//     </>
//   );
// };

// export default AdminSectorsTable;




import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import PrimaryButton from "../buttons/PrimaryButton";
import { parseISO, format } from "date-fns";
import axios from "axios";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Modal from "../modal/Modal";
import Pagination from "../pagination/Pagination";
import PageSizeSelector from "../pagination/PageSizeSelector";
import Cookies from "js-cookie";
import confirmIcon from "../../assets/img/iconamoon--shield-yes-fill.svg";
import usePaginatedData from "../pagination/hooks/usePaginatedData";

const AdminSectorsTable = ({
  pending,
  searchQuery,
  startDate,
  endDate,
  refreshTrigger,
}) => {
  // Configuration for endpoints and transform functions
  const endpoints = {
    users: pending ? `/api/users/requests` : `/api/users`,
  };

  const transformFunctions = {
    users: (data) => {
      return data
        .map((user) => ({
          ...user,
          uuid: user.uuid || user.id, // Ensure uuid is available
        }))
        .sort((a, b) => {
          // Sort "Not Active" users to the bottom
          if (a.status === "Not Active" && b.status !== "Not Active") return 1;
          if (a.status !== "Not Active" && b.status === "Not Active") return -1;
          
          // Sort by createdAt (newest first)
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
    }
  };

  // Use the pagination hook
  const {
    data: filteredUsers,
    pagination,
    loading,
    error: fetchError,
    goToPage,
    changePageSize,
    refresh
  } = usePaginatedData({
    activeTab: "users",
    searchQuery,
    startDate,
    endDate,
    endpoints,
    transformFunctions,
  });

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [loadingState, setLoadingState] = useState({ id: null, action: null });
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [error, setError] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [multipleDeleteLoading, setMultipleDeleteLoading] = useState(false);
  const [multipleActionLoading, setMultipleActionLoading] = useState(false);
  const [showActionSuccess, setShowActionSuccess] = useState(false);
  const [showActionConfirm, setShowActionConfirm] = useState(false);
  const [actionUser, setActionUser] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [isMultipleAction, setIsMultipleAction] = useState(false);
  const [showReactivateConfirm, setShowReactivateConfirm] = useState(false);
  const [userToReactivate, setUserToReactivate] = useState(null);

  // Re-assign role states
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [userToReassign, setUserToReassign] = useState(null);
  const [newRole, setNewRole] = useState("");
  const [newName, setNewName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [reassignLoading, setReassignLoading] = useState(false);
  const [reassignError, setReassignError] = useState("");
  const [showReassignSuccess, setShowReassignSuccess] = useState(false);

  // Location states for scanner assistant
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [sites, setSites] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [locationError, setLocationError] = useState("");

  // Reset selected records when page changes or data updates
  useEffect(() => {
    setSelectedUsers([]);
    setIsAllSelected(false);
  }, [pagination.currentPage, filteredUsers, refreshTrigger]);

  // Refresh data when refreshTrigger changes
  useEffect(() => {
    if (refreshTrigger) {
      refresh();
    }
  }, [refreshTrigger, refresh]);

  const formatDate = (dateString) => {
    const parsedDate = parseISO(dateString);
    return format(parsedDate, "dd MMM yyyy");
  };

  const formatStatus = (status) => {
    if (!status) return "";
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  const actionDisabled = (status) => {
    return status === "APPROVED" || status === "REJECTED";
  };

  const deleteDisabled = (status) => {
    return status === "Not Active";
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setIsAllSelected(isChecked);

    if (isChecked) {
      setSelectedUsers(
        filteredUsers
          .filter(
            (user) =>
              !actionDisabled(user.status) && !deleteDisabled(user.status)
          )
          .map((user) => user.uuid || user.id)
      );
    } else {
      setSelectedUsers([]);
    }
  };

  const handleSelectUser = (e, userId) => {
    const isChecked = e.target.checked;

    setSelectedUsers((prev) => {
      const newSelected = isChecked
        ? [...prev, userId]
        : prev.filter((id) => id !== userId);
      
      const availableForSelection = filteredUsers.filter(
        (user) => !actionDisabled(user.status) && !deleteDisabled(user.status)
      );
      
      setIsAllSelected(newSelected.length === availableForSelection.length);
      return newSelected;
    });
  };

  const handlePageChange = (newPage) => {
    goToPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value);
    changePageSize(newPageSize);
  };

  const handleDeleteClick = (user) => {
    setUserToDelete(user);
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = async () => {
    setLoadingState({ id: userToDelete.uuid, action: "DELETE" });
    setConfirmLoading(true);
    try {
      const token = Cookies.get("token");
      const res = await axios.delete(
        `${baseUrl}/api/users/${userToDelete.uuid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.status === 200) {
        setIsMultipleDelete(false);
        setShowDeleteSuccess(true);
        // Refresh the current page to show updated data
        refresh();
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          setError("Error: User does not exist.");
        } else {
          console.error("Error deleting user:", error);
          setError("Error deleting user. Please try again.");
        }
      }
    } finally {
      setLoadingState({ id: null, action: null });
      setUserToDelete(null);
      setConfirmLoading(false);
      setShowDeleteConfirm(false);
    }
  };

  const getStatusClass = (status) => {
    const statusMap = {
      APPROVED: "status-approved",
      REJECTED: "status-declined",
      PENDING: "status-pending",
      Active: "status-active",
      Inactive: "status-inactive",
      "Not Active": "status-inactive",
    };
    return `status ${statusMap[status]}`;
  };

  const formatRole = (role) => {
    const roleMap = {
      SUPER_ADMIN: "Super Admin",
      CLIENT: "Stakeholder",
      SCANNER_OPERATOR: "Scanner Operator",
      DATA_ENTRY_CLERK: "Data Entry Clerk",
      PROJECT_COORDINATOR: "Project Coordinator",
      SCANNER_ASSISTANT: "Scanner Assistant",
      SUPERVISOR: "Supervisor",
    };
    return roleMap[role] || role;
  };

  const updateUserStatus = async (id, status) => {
    setLoadingState({ id, action: status });
    setShowActionConfirm(false);
    try {
      const token = Cookies.get("token");
      const res = await axios.put(
        `${baseUrl}/api/users/requests/${id}`,
        { status },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.status === 200) {
        setIsMultipleAction(false);
        setShowActionSuccess(true);
        // Refresh the current page to show updated data
        refresh();
      }
    } catch (error) {
      setError(error.response?.data?.error || "Error updating status");
    } finally {
      setLoadingState({ id: null, action: null });
      setActionUser(null);
    }
  };

  const handleMultipleDelete = async () => {
    if (selectedUsers.length === 0) return;

    setMultipleDeleteLoading(true);
    setShowDeleteConfirm(false);

    try {
      const token = Cookies.get("token");
      const res = await axios.delete(`${baseUrl}/api/users/multiple/delete`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { uuids: selectedUsers },
      });

      if (res.status === 200) {
        setSelectedUsers([]);
        setIsAllSelected(false);
        setIsMultipleDelete(true);
        setShowDeleteSuccess(true);
        // Refresh the current page to show updated data
        refresh();
      }
    } catch (error) {
      setError("Error deleting multiple users");
    } finally {
      setMultipleDeleteLoading(false);
    }
  };

  const handleMultipleAction = async (status) => {
    if (selectedUsers.length === 0) return;

    setMultipleActionLoading(true);
    setShowActionConfirm(false);

    try {
      const token = Cookies.get("token");
      const res = await axios.put(
        `${baseUrl}/api/users/multiple/requests`,
        { ids: selectedUsers, status },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.status === 200) {
        setSelectedUsers([]);
        setIsAllSelected(false);
        setShowActionSuccess(true);
        setIsMultipleAction(true);
        // Refresh the current page to show updated data
        refresh();
      }
    } catch (error) {
      const data = error.response?.data;
      const message = data?.emails?.length
        ? `${data.error}: ${data.emails.join(", ")}`
        : data?.error || "Error updating multiple users";
      setError(message);
    } finally {
      setMultipleActionLoading(false);
    }
  };

  // handle multiple delete click with multiple users
  const handleMultipleDeleteClick = () => {
    if (selectedUsers.length > 0) {
      setShowDeleteConfirm(true);
    }
  };

  const handleActionClick = (user, status) => {
    setActionUser(user);
    setActionType(status);
    setShowActionConfirm(true);
  };

  const handleMultipleApproveClick = () => {
    if (selectedUsers.length > 0) {
      setActionType("APPROVED");
      setShowActionConfirm(true);
    }
  };

  const handleMultipleRejectClick = () => {
    if (selectedUsers.length > 0) {
      setActionType("REJECTED");
      setShowActionConfirm(true);
    }
  };

  const handleCloseActionConfirm = () => {
    setShowActionConfirm(false);
    setActionUser(null);
    setActionType(null);
  };

  const handleCloseActionSuccess = () => {
    setShowActionSuccess(false);
    setActionType(null);
    setIsMultipleAction(false);
  };

  const handleCloseReactivateConfirm = () => {
    setShowReactivateConfirm(false);
    setUserToReactivate(null);
  };

  const handleCloseModal = () => {
    setShowDeleteConfirm(false);
  };

  const handleCloseDeleteSuccess = () => {
    setShowDeleteSuccess(false);
    setIsMultipleDelete(false);
  };

  useEffect(() => {
    let timer;
    if (showDeleteSuccess) {
      timer = setTimeout(() => {
        handleCloseDeleteSuccess();
      }, 3000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [showDeleteSuccess]);

  useEffect(() => {
    let timer;
    if (showActionSuccess) {
      timer = setTimeout(() => {
        handleCloseActionSuccess();
      }, 3000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [showActionSuccess]);

  const handleReactivateUser = async (user) => {
    setUserToReactivate(user);
    setShowReactivateConfirm(true);
  };

  const handleConfirmReactivate = async () => {
    setLoadingState({ id: userToReactivate.uuid, action: "REACTIVATE" });
    setError("");
    try {
      const token = Cookies.get("token");
      const res = await axios.put(
        `${baseUrl}/api/users/${userToReactivate.uuid}/reactivate`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.status === 200) {
        setShowReactivateConfirm(false);
        setUserToReactivate(null);
        // Refresh the current page to show updated data
        refresh();
      }
    } catch (error) {
      setError("Error reactivating user");
    } finally {
      setLoadingState({ id: null, action: null });
    }
  };

  // Re-assign role functions
  const handleReassignRole = (user) => {
    setUserToReassign(user);
    setNewRole(user.role);
    setNewName(user.name);
    setNewEmail(user.email);
    setSelectedProvince("");
    setSelectedDistrict("");
    setSelectedSector("");
    setReassignError("");
    setLocationError("");
    setShowReassignModal(true);
  };

  const handleCloseReassignModal = () => {
    setShowReassignModal(false);
    setUserToReassign(null);
    setNewRole("");
    setSelectedProvince("");
    setSelectedDistrict("");
    setSelectedSector("");
    setReassignError("");
    setLocationError("");
  };

  const handleCloseReassignSuccess = () => {
    setShowReassignSuccess(false);
  };

  // Fetch location data when role changes to SCANNER_ASSISTANT
  useEffect(() => {
    if (showReassignModal && newRole === "SCANNER_ASSISTANT") {
      const fetchSites = async () => {
        try {
          const token = Cookies.get("token");
          const response = await axios.get(`${baseUrl}/api/sites`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const sitesData = response.data;
          setSites(sitesData);

          const uniqueProvinces = [
            ...new Set(sitesData.map((site) => site.province)),
          ].sort();
          const uniqueDistricts = [
            ...new Set(sitesData.map((site) => site.district)),
          ].sort();
          const uniqueSectors = [
            ...new Set(
              sitesData
                .map((site) => site.sector)
                .filter((sector) => sector !== null)
            ),
          ].sort();

          setProvinces(uniqueProvinces);
          setDistricts(uniqueDistricts);
          setSectors(uniqueSectors);
        } catch (error) {
          setReassignError("Failed to load location data");
        }
      };

      fetchSites();
    } else {
      setProvinces([]);
      setDistricts([]);
      setSectors([]);
      setSites([]);
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedSector("");
      setLocationError("");
    }
  }, [showReassignModal, newRole, baseUrl]);

  const handleRoleChange = (e) => {
    setNewRole(e.target.value);
    setSelectedProvince("");
    setSelectedDistrict("");
    setSelectedSector("");
    setLocationError("");
  };

  const handleProvinceChange = (e) => {
    setSelectedProvince(e.target.value);
    setSelectedDistrict("");
    setSelectedSector("");
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
    setSelectedSector("");
  };

  const handleSectorChange = (e) => {
    setSelectedSector(e.target.value);
  };

  const validateReassignForm = () => {
    if (!newRole) {
      setReassignError("Please select a role");
      return false;
    }

    if (
      newRole === "SCANNER_ASSISTANT" &&
      (!selectedProvince || !selectedDistrict)
    ) {
      setLocationError(
        "Province and district are required for Scanner Assistant"
      );
      return false;
    }

    return true;
  };

  const handleSubmitReassign = async (e) => {
    e.preventDefault();

    if (!validateReassignForm()) {
      return;
    }

    setReassignLoading(true);
    setReassignError("");
    setLocationError("");

    try {
      const token = Cookies.get("token");
      const requestData = {
        ...(newName.trim() && { name: newName }),
        ...(newEmail.trim() && { email: newEmail }),
        role: newRole,
        ...(newRole === "SCANNER_ASSISTANT" && {
          province: selectedProvince,
          district: selectedDistrict,
          ...(selectedSector && { sector: selectedSector }),
        }),
      };

      const res = await axios.put(
        `${baseUrl}/api/users/${userToReassign.uuid}/update-role`,
        requestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.status === 200) {
        setShowReassignModal(false);
        setShowReassignSuccess(true);
        // Refresh the current page to show updated data
        refresh();
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          setReassignError(
            "A scanner assistant is already assigned to this site."
          );
        } else if (error.response.status === 400) {
          setReassignError(error.response.data.error || "Invalid input");
        } else if (error.response.status === 404) {
          setReassignError("Site not found");
        } else {
          setReassignError(
            error.response.data.error || "Error updating user role"
          );
        }
      } else {
        setReassignError("Server is not responding. Please try again later");
      }
    } finally {
      setReassignLoading(false);
    }
  };

  // Auto-close success modal
  useEffect(() => {
    let timer;
    if (showReassignSuccess) {
      timer = setTimeout(() => {
        handleCloseReassignSuccess();
      }, 3000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [showReassignSuccess]);

  return (
    <>
      {/* Page Size Selector */}
      <div className="table-header-controls">
        <PageSizeSelector
          value={pagination.itemsPerPage}
          onChange={handlePageSizeChange}
          disabled={loading}
        />
        
        {/* Show error message if fetch failed */}
        {fetchError && (
          <div className="error-message">
            <span style={{ color: "#E20000", marginRight: "10px" }}>
              Error: {fetchError}
            </span>
            <button
              onClick={refresh}
              className="retry-button"
              disabled={loading}
            >
              <Icon icon="iconamoon:restart" width="16" height="16" />
              Retry
            </button>
          </div>
        )}

        {/* Show error message if an approve/reject/delete action failed */}
        {error && (
          <div className="error-message">
            <span style={{ color: "#E20000", marginRight: "10px" }}>
              Error: {error}
            </span>
            <button
              onClick={() => setError("")}
              className="retry-button"
            >
              Dismiss
            </button>
          </div>
        )}
      </div>

      {selectedUsers.length > 0 && !pending && (
        <div
          className="table-controls"
          style={{ marginBottom: "20px", marginRight: "20px" }}
        >
          <PrimaryButton
            text={
              multipleDeleteLoading ? (
                <AiOutlineLoading3Quarters className="loader" />
              ) : (
                `Delete ${selectedUsers.length} User${
                  selectedUsers.length > 1 ? "s" : ""
                }`
              )
            }
            icon="mingcute:delete-fill"
            onClick={handleMultipleDeleteClick}
            disabled={multipleDeleteLoading}
            style={{ backgroundColor: "#E2000033", color: "#E20000" }}
          />
        </div>
      )}

      {selectedUsers.length > 0 && pending && (
        <div
          className="table-controls"
          style={{ marginBottom: "20px", marginRight: "20px" }}
        >
          <PrimaryButton
            text={
              multipleActionLoading && actionType === "APPROVED" ? (
                <AiOutlineLoading3Quarters className="loader" />
              ) : (
                `Approve ${selectedUsers.length} User${
                  selectedUsers.length > 1 ? "s" : ""
                }`
              )
            }
            icon="dashicons:yes"
            onClick={handleMultipleApproveClick}
            disabled={multipleActionLoading}
            style={{ backgroundColor: "#078ECE", color: "#FFFFFF" }}
          />
          <PrimaryButton
            text={
              multipleActionLoading && actionType === "REJECTED" ? (
                <AiOutlineLoading3Quarters className="loader" />
              ) : (
                `Reject ${selectedUsers.length} User${
                  selectedUsers.length > 1 ? "s" : ""
                }`
              )
            }
            icon="dashicons:no"
            onClick={handleMultipleRejectClick}
            disabled={multipleActionLoading}
            style={{
              backgroundColor: "#E2000033",
              color: "#E20000",
              marginLeft: "20px",
              marginTop: "10px",
            }}
          />
        </div>
      )}
      
      <table className="admin">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                id="selectAll"
                checked={isAllSelected}
                onChange={handleSelectAll}
                disabled={loading}
              />
            </th>
            <th>Name</th>
            <th>Email ID</th>
            <th>Role</th>
            <th>Status</th>
            <th>Date</th>
            <th style={{ textAlign: "center" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <tr key={index}>
                <td>
                  <Skeleton width={20} height={20} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={150} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={80} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
              </tr>
            ))
          ) : filteredUsers.length === 0 ? (
            <tr style={{ boxShadow: "none" }}>
              <td colSpan="7" style={{ textAlign: "center", color: "#9B9B9B" }}>
                No users found
              </td>
            </tr>
          ) : (
            filteredUsers.map((user, index) => (
              <tr key={user.uuid || user.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedUsers.includes(user.uuid || user.id)}
                    onChange={(e) => handleSelectUser(e, user.uuid || user.id)}
                    disabled={
                      actionDisabled(user.status) || deleteDisabled(user.status)
                    }
                  />
                </td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{formatRole(user.role)}</td>
                <td>
                  <span className={getStatusClass(user.status)}>
                    {formatStatus(user.status)}
                  </span>
                </td>
                <td>{formatDate(user.createdAt)}</td>
                {!pending && (
                  <td
                    className="delete"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    {user.status === "Not Active" ? (
                      <PrimaryButton
                        text={
                          loadingState.id === user.uuid &&
                          loadingState.action === "REACTIVATE" ? (
                            <AiOutlineLoading3Quarters className="loader" />
                          ) : (
                            "Reactivate"
                          )
                        }
                        icon="material-symbols:restart-alt"
                        onClick={() => handleReactivateUser(user)}
                        disabled={
                          loadingState.id === user.uuid &&
                          loadingState.action === "REACTIVATE"
                        }
                        style={{
                          backgroundColor:
                            loadingState.id === user.uuid &&
                            loadingState.action === "REACTIVATE"
                              ? "#cccccc"
                              : "#E6F4EA",
                          color:
                            loadingState.id === user.uuid &&
                            loadingState.action === "REACTIVATE"
                              ? "#666666"
                              : "#007011",
                          minWidth: 110,
                          cursor:
                            loadingState.id === user.uuid &&
                            loadingState.action === "REACTIVATE"
                              ? "not-allowed"
                              : "pointer",
                        }}
                      />
                    ) : (
                      <>
                        <a
                          onClick={() => handleReassignRole(user)}
                          style={{ backgroundColor: "#4E7FFF33" }}
                        >
                          <Icon
                            icon="mdi:book-edit"
                            width="20"
                            height="20"
                            color="#4E7FFF"
                          />
                        </a>
                        <a
                          onClick={() => handleDeleteClick(user)}
                          aria-label="Delete"
                          className={`${
                            loadingState.id === user.uuid ||
                            deleteDisabled(user.status)
                              ? "btn-disabled"
                              : ""
                          }`}
                          disabled={
                            loadingState.id === user.uuid ||
                            deleteDisabled(user.status)
                          }
                        >
                          <Icon
                            icon="mingcute:delete-fill"
                            width="20"
                            height="20"
                            color="#E20000"
                          />
                        </a>
                      </>
                    )}
                  </td>
                )}
                {pending && (
                  <td>
                    <div className="action-buttons">
                      <PrimaryButton
                        text={
                          loadingState.id === user.id &&
                          loadingState.action === "APPROVED" ? (
                            <AiOutlineLoading3Quarters className="loader" />
                          ) : (
                            "Approve"
                          )
                        }
                        icon="dashicons:yes"
                        className={`${
                          loadingState.id === user.id &&
                          loadingState.action === "APPROVED"
                            ? "btn-disabled"
                            : ""
                        } ${actionDisabled(user.status) ? "btn-disabled" : ""}`}
                        disabled={
                          loadingState.id === user.id ||
                          actionDisabled(user.status)
                        }
                        onClick={() => handleActionClick(user, "APPROVED")}
                      />
                      <PrimaryButton
                        text={
                          loadingState.id === user.id &&
                          loadingState.action === "REJECTED" ? (
                            <AiOutlineLoading3Quarters className="loader" />
                          ) : (
                            "Decline"
                          )
                        }
                        className={`${
                          loadingState.id === user.id &&
                          loadingState.action === "REJECTED"
                            ? "btn-disabled"
                            : ""
                        } ${actionDisabled(user.status) ? "btn-disabled" : ""}`}
                        disabled={
                          loadingState.id === user.id ||
                          actionDisabled(user.status)
                        }
                        onClick={() => handleActionClick(user, "REJECTED")}
                      />
                    </div>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Updated Pagination */}
      {!loading && pagination.totalPages > 1 && (
        <Pagination
          currentPage={pagination.currentPage}
          totalItems={pagination.totalItems}
          entriesPerPage={pagination.itemsPerPage}
          onPageChange={handlePageChange}
        />
      )}

      {/* All the existing modals remain the same */}
      {showDeleteConfirm && (
        <Modal
          onClose={() => setShowDeleteConfirm(false)}
          show={showDeleteConfirm}
        >
          <div className="content confirmation">
            <h2>Confirm Delete</h2>
            <div className="text">
              {selectedUsers.length > 1 ? (
                <>
                  Are you sure you want to delete the following{" "}
                  {selectedUsers.length} users?
                  <ul style={{ listStyleType: "none", padding: "10px 0" }}>
                    {filteredUsers
                      .filter((user) =>
                        selectedUsers.includes(user.uuid || user.id)
                      )
                      .map((user) => (
                        <li key={user.uuid || user.id}>
                          <strong>{user.name}</strong> ({user.email}) -{" "}
                          {formatRole(user.role)}
                        </li>
                      ))}
                  </ul>
                </>
              ) : (
                <>
                  Are you sure you want to delete the user: {userToDelete?.name}{" "}
                  ({userToDelete?.email}) with the role{" "}
                  <strong>{formatRole(userToDelete?.role)}</strong>?
                </>
              )}
            </div>
            <div className="button-group">
              <PrimaryButton
                text={
                  confirmLoading || multipleDeleteLoading ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Yes"
                  )
                }
                onClick={
                  selectedUsers.length > 1
                    ? handleMultipleDelete
                    : handleConfirmDelete
                }
                disabled={confirmLoading || multipleDeleteLoading}
              />
              <PrimaryButton
                text="No"
                onClick={handleCloseModal}
                disabled={confirmLoading || multipleDeleteLoading}
              />
            </div>
          </div>
        </Modal>
      )}

      {showActionConfirm && (
        <Modal onClose={handleCloseActionConfirm} show={showActionConfirm}>
          <div className="content confirmation">
            <h2>
              {actionType === "APPROVED"
                ? "Confirm Approval"
                : actionType === "REJECTED"
                ? "Confirm Rejection"
                : "Confirm Action"}
            </h2>
            <div className="text">
              {selectedUsers.length > 1 ? (
                <>
                  Are you sure you want to{" "}
                  {actionType === "APPROVED" ? "approve" : "reject"} the
                  following {selectedUsers.length} users?
                  <ul style={{ listStyleType: "none", padding: "10px 0" }}>
                    {filteredUsers
                      .filter((user) =>
                        selectedUsers.includes(user.uuid || user.id)
                      )
                      .map((user) => (
                        <li key={user.uuid || user.id}>
                          <strong>{user.name}</strong> ({user.email}) -{" "}
                          {formatRole(user.role)}
                        </li>
                      ))}
                  </ul>
                </>
              ) : actionUser ? (
                <>
                  Are you sure you want to {actionType?.toLowerCase()} this
                  user: <strong>{actionUser?.name}</strong> ({actionUser?.email}
                  ) with the role {formatRole(actionUser?.role)}?
                </>
              ) : (
                <p>Are you sure you want to delete this user?</p>
              )}
            </div>
            <div className="button-group">
              <PrimaryButton
                text={
                  loadingState.id || multipleActionLoading ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Yes"
                  )
                }
                onClick={
                  selectedUsers.length > 1
                    ? () => handleMultipleAction(actionType)
                    : () => updateUserStatus(actionUser.id, actionType)
                }
                disabled={loadingState.id || multipleActionLoading}
              />
              <PrimaryButton
                text="No"
                onClick={handleCloseActionConfirm}
                disabled={loadingState.id || multipleActionLoading}
              />
            </div>
          </div>
        </Modal>
      )}

      {showDeleteSuccess && (
        <Modal onClose={handleCloseDeleteSuccess} show={showDeleteSuccess}>
          <div className="content confirmation">
            <div className="icon-container">
              <img
                src={confirmIcon}
                alt="confirm"
                width="57"
                height="57"
                style={{ color: "#007011" }}
              />
            </div>
            <div className="text">
              {isMultipleDelete
                ? "Users have been successfully deleted!"
                : "User has been successfully deleted!"}
            </div>
          </div>
        </Modal>
      )}

      {showActionSuccess && (
        <Modal onClose={handleCloseActionSuccess} show={showActionSuccess}>
          <div className="content confirmation">
            <div className="icon-container">
              <img
                src={confirmIcon}
                alt="confirm"
                width="57"
                height="57"
                style={{ color: "#007011" }}
              />
            </div>
            <div className="text">
              {isMultipleAction
                ? `Users have been successfully ${
                    actionType === "APPROVED" ? "approved" : "declined"
                  }!`
                : `User has been successfully ${
                    actionType === "APPROVED" ? "approved" : "declined"
                  }!`}
            </div>
          </div>
        </Modal>
      )}

      {showReactivateConfirm && (
        <Modal
          onClose={handleCloseReactivateConfirm}
          show={showReactivateConfirm}
        >
          <div className="content confirmation">
            <h2>Confirm Reactivation</h2>
            <div className="text">
              Are you sure you want to reactivate the user:{" "}
              {userToReactivate?.name}({userToReactivate?.email}) with the role{" "}
              {formatRole(userToReactivate?.role)}?
            </div>
            <div className="button-group">
              <PrimaryButton
                text={
                  loadingState.id ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Yes"
                  )
                }
                onClick={handleConfirmReactivate}
                disabled={loadingState.id}
              />
              <PrimaryButton
                text="No"
                onClick={handleCloseReactivateConfirm}
                disabled={loadingState.id}
              />
            </div>
          </div>
        </Modal>
      )}

      {/* Re-assign Role Modal */}
      {showReassignModal && (
        <Modal show={showReassignModal} onClose={handleCloseReassignModal}>
          <div className="title">UPDATE USER DETAILS</div>
          <div className="content">
            <div className="form-container">
              <form onSubmit={handleSubmitReassign}>
                <div className="email-and-password">
                  <div className="label">
                    <div>Name</div>
                    <input
                      placeholder="User name"
                      type="text"
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                    />
                  </div>

                  <div className="label">
                    <div>Email</div>
                    <input
                      placeholder="User email"
                      type="text"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="label">
                  <div>Current Role</div>
                  <input
                    placeholder="Current role"
                    type="text"
                    value={formatRole(userToReassign?.role) || ""}
                    disabled
                  />
                </div>

                <div className="label">
                  <div>New Role</div>
                  <select value={newRole} onChange={handleRoleChange}>
                    <option value="" disabled>
                      Select New Role
                    </option>
                    <option value="SUPER_ADMIN">Admin</option>
                    <option value="SCANNER_OPERATOR">Scanner Operator</option>
                    <option value="CLIENT">Stakeholder</option>
                    <option value="DATA_ENTRY_CLERK">Data Entry Clerk</option>
                    <option value="PROJECT_COORDINATOR">
                      Project Coordinator
                    </option>
                    <option value="SUPERVISOR">Supervisor</option>
                    <option value="SCANNER_ASSISTANT">Scanner Assistant</option>
                  </select>
                </div>

                {newRole === "SCANNER_ASSISTANT" && (
                  <>
                    <div className="label">
                      <div>Province</div>
                      <select
                        name="province"
                        value={selectedProvince}
                        onChange={handleProvinceChange}
                        required
                      >
                        <option value="" disabled>
                          Select Province
                        </option>
                        {provinces.map((province) => (
                          <option key={province} value={province}>
                            {province}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="label">
                      <div>District</div>
                      <select
                        name="district"
                        value={selectedDistrict}
                        onChange={handleDistrictChange}
                        disabled={!selectedProvince}
                        required
                      >
                        <option value="" disabled>
                          Select District
                        </option>
                        {districts
                          .filter((district) =>
                            sites.some(
                              (site) =>
                                site.province === selectedProvince &&
                                site.district === district
                            )
                          )
                          .map((district) => (
                            <option key={district} value={district}>
                              {district}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="label">
                      <div>Sector</div>
                      <select
                        name="sector"
                        value={selectedSector}
                        onChange={handleSectorChange}
                        disabled={!selectedDistrict}
                      >
                        <option value="" disabled>
                          Select Sector (Optional)
                        </option>
                        {sectors
                          .filter((sector) =>
                            sites.some(
                              (site) =>
                                site.province === selectedProvince &&
                                site.district === selectedDistrict &&
                                site.sector === sector
                            )
                          )
                          .map((sector) => (
                            <option key={sector} value={sector}>
                              {sector}
                            </option>
                          ))}
                      </select>
                    </div>
                  </>
                )}
              </form>
              {reassignError && (
                <div className="error-message">{reassignError}</div>
              )}
              {locationError && (
                <div className="error-message">{locationError}</div>
              )}
            </div>
            <div className="button-group">
              <PrimaryButton
                text={
                  reassignLoading ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Update User"
                  )
                }
                onClick={handleSubmitReassign}
                disabled={reassignLoading}
              />
              <PrimaryButton
                text="Cancel"
                onClick={handleCloseReassignModal}
                disabled={reassignLoading}
              />
            </div>
          </div>
        </Modal>
      )}

      {/* Re-assign Success Modal */}
      {showReassignSuccess && (
        <Modal onClose={handleCloseReassignSuccess} show={showReassignSuccess}>
          <div className="content confirmation">
            <div className="icon-container">
              <img
                src={confirmIcon}
                alt="confirm"
                width="57"
                height="57"
                style={{ color: "#007011" }}
              />
            </div>
            <div className="text">User role has been successfully updated!</div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AdminSectorsTable;